import React from 'react';
import ln from '../../assets/linkedin.png';
import github from '../../assets/github.png';

export default function Footer() {
  return (
    <footer className="py-8 bg-slate-950 text-white text-center mt-12">
      <div className="mb-4 flex justify-center gap-4">
        <a href="https://www.linkedin.com/in/AniketnShukla" target="_blank" rel="noopener noreferrer" className="inline-block p-2 rounded-full bg-slate-900 hover:bg-cyan-600 transition-colors duration-200">
          <img src={ln} alt="LinkedIn" className="h-6 w-6" />
        </a>
        <a href="https://github.com/AniketnShukla" target="_blank" rel="noopener noreferrer" className="inline-block p-2 rounded-full bg-slate-900 hover:bg-cyan-600 transition-colors duration-200">
          <img src={github} alt="GitHub" className="h-6 w-6" />
        </a>
        <a href="/resume.pdf" target="_blank" rel="noopener noreferrer" className="inline-block p-2 rounded-full bg-slate-900 hover:bg-cyan-600 transition-colors duration-200">
          <span className="font-semibold text-cyan-400">Resume</span>
        </a>
      </div>
      <div className="text-sm text-slate-400 mb-2">Built with <span className="text-cyan-400 font-semibold">React</span>, <span className="text-cyan-400 font-semibold">Tailwind</span>, <span className="text-cyan-400 font-semibold">Framer Motion</span></div>
      <div className="text-xs text-slate-500">&copy; {new Date().getFullYear()} Aniket Shukla. All rights reserved.</div>
    </footer>
  );
} 